import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class PointItem extends BaseModel {
  mainPoint?: string;
  subPoints?: string[];

  constructor(model: Partial<PointItem> = {}) {
    super(model);

    this.mainPoint = model.mainPoint;
    this.subPoints = model.subPoints;
  }
}
